import type {Request} from 'express';

export enum SERVER_RENDERING_MODE {
  SSR = 'ssr', // Full Server-Side Rendering, no optimizations
  SSR_SEO_BOT = 'ssr_seo_bot', // Server-Side Rendering optimized for SEO bots
  CSR = 'csr', // Basic skeleton SSR and then Client-Side Rendering
}

const RENDERING_MODIFYING_HEADERS = {
  DEVICE: 'X-UA-Device',
  CLIENT_SIDE_RENDERING: 'X-CSR',
};

export const getServerRenderingMode = ({req}: {req: Request}) => {
  if (
    req.query.ssr === '0' ||
    req.header(RENDERING_MODIFYING_HEADERS.CLIENT_SIDE_RENDERING) === '1'
  ) {
    return SERVER_RENDERING_MODE.CSR;
  }

  if (
    req.header(RENDERING_MODIFYING_HEADERS.DEVICE)?.includes('bot') ||
    req.query.enableBotMode === '1'
  ) {
    return SERVER_RENDERING_MODE.SSR_SEO_BOT;
  }

  // Default rendering mode is full SSR
  return SERVER_RENDERING_MODE.SSR;
};
